<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'FrameCropImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'crop',
      title: 'Crop',
      showLocal: true,
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = this.canvas.getActiveObject().get('type') === 'image';
      } else {
        this.showLocal = false;
      }
    },
    action() {
      this.$emit('show-cropper');
      // Old way to change crop mode
      this.$emit('changeMode', 'cropping');
    },
    complete() {
      this.$emit('hide-cropper');
      // Old way to change crop mode
      this.$emit('changeMode', null);
    },
  },
};
</script>
